
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#fff","stroke-width":"2","stroke-linecap":"round","d":"M17.639 39.551h28.082M17.639 44.511h28.082M17.639 49.472h28.082"}}),_c('path',{attrs:{"d":"M31.68 23.282a4.493 4.493 0 100-8.986 4.493 4.493 0 000 8.986zM22.874 34.142a8.986 8.986 0 0117.612 0","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M49.77 8.966H14.23c-1.784 0-3.23 1.64-3.23 3.66v40.266c0 2.021 1.447 3.66 3.23 3.66h35.54c1.783 0 3.23-1.639 3.23-3.66V12.627c0-2.022-1.447-3.66-3.23-3.66z","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    